import { render } from "./StorePreviewDetail.vue?vue&type=template&id=380b43c8&scoped=true"
import script from "./StorePreviewDetail.vue?vue&type=script&lang=js"
export * from "./StorePreviewDetail.vue?vue&type=script&lang=js"

import "./StorePreviewDetail.vue?vue&type=style&index=0&id=380b43c8&lang=css"
import "./StorePreviewDetail.vue?vue&type=style&index=1&id=380b43c8&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380b43c8"]])

export default __exports__